import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import appConfig from '../config';
import * as dd from 'dingtalk-jsapi';
import store from '../store';
import {geturlParams} from "../utils/index"

Vue.use(VueRouter);

// fix NavigationDuplicated 错误
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const router = new VueRouter({
  mode: 'history',
  base: appConfig.publicPath,
  routes,
});


// 获取权限，路由守护，权限拦截，设置PV埋点
router.beforeEach(async (to, from, next) => {
  // 本地开发不验证
  if (process.env.VUE_APP_RUN_ENV === 'dev') return next();

  // 特斯拉模块应用不做限制
  if (to.path.startsWith('/tesla')) {
    return next();
  }

  // 不在钉钉内打开跳转页面
  if (dd.env.platform === 'notInDingTalk') {
    if(geturlParams()["Api-Version"]){
      return next()

    }
    if (to.path === '/notfoundInDD') {
      return next();
    } else {

      return next('/notfoundInDD');
    }
  }

  // 修改钉钉title
  dd.biz.navigation.setTitle({
    title: to.meta.title ? to.meta.title : '未来不远',
  });

  // 判断登陆
  if (!window.sessionStorage.getItem('dingdingAuth')) {
    const res = await store.dispatch('dingdingLogin');
    if (res) return next();
  } else {
    next();
  }

});

export { routes };

export default router;
